<script>
  import { fade } from "svelte/transition";
  import { onMount, tick } from "svelte";
  import { quadOut } from "svelte/easing";
  export let radius;
  export let stroke;
  export let progress;
  export let maxRating;

  const VIEWS = { svg: null };

  let innerHeight;
  let scrollY;
  let offset;
  let showRating = false;
  let overallDisplay = 0;

  $: if (VIEWS.svg && scrollY) {
    var rect = VIEWS.svg.getBoundingClientRect();
    offset = innerHeight - rect.top;
  }

  const normalizedRadius = radius - stroke * 2;
  const circumference = normalizedRadius * 2 * Math.PI;

  const strokeDashoffset =
    circumference - (progress / maxRating) * circumference;

  $: if (!showRating && offset > 200) {
    showRating = true;
    animateOverallDisplay(1000);
  }

  function animateOverallDisplay(duration = 2000) {
    const overall = Math.round(progress * 10) / 10;
    const step = (overall * 17) / duration;
    let time = 0;
    let stepsGone = 0;
    const timer = setInterval(() => {
      stepsGone++;
      time += 17;
      const newOverallDisplay = Math.round(step * stepsGone * 10) / 10;
      if (overallDisplay < newOverallDisplay) {
        overallDisplay = newOverallDisplay;
      }
      if (time >= duration) {
        overallDisplay = overall;
        clearInterval(timer);
      }
    }, 17);
  }

  function grow(node, { duration }) {
    return {
      duration,
      css: t => {
        const eased = quadOut(t);

        return `
					stroke-dashoffset: ${circumference -
            (circumference - strokeDashoffset) * eased};`;
      }
    };
  }

  var ratingColors = [
    { rat: 0, color: { r: 0xff, g: 0x00, b: 0 } },
    { rat: maxRating / 2, color: { r: 0xff, g: 0xad, b: 0 } },
    { rat: maxRating, color: { r: 0x30, g: 0xad, b: 0 } }
  ];

  const getColorForRating = function(rat) {
    for (var i = 1; i < ratingColors.length - 1; i++) {
      if (rat < ratingColors[i].rat) {
        break;
      }
    }
    var lower = ratingColors[i - 1];
    var upper = ratingColors[i];
    var range = upper.rat - lower.rat;
    var rangeRat = (rat - lower.rat) / range;
    var ratLower = 1 - rangeRat;
    var ratUpper = rangeRat;
    var color = {
      r: Math.floor(lower.color.r * ratLower + upper.color.r * ratUpper),
      g: Math.floor(lower.color.g * ratLower + upper.color.g * ratUpper),
      b: Math.floor(lower.color.b * ratLower + upper.color.b * ratUpper)
    };
    return "rgb(" + [color.r, color.g, color.b].join(",") + ")";
  };
</script>

<style>
  .progress-indicator {
    stroke-dashoffset: var(--circumference);
  }
</style>

<svelte:window bind:scrollY bind:innerHeight />

<svg
  viewBox={`${0} ${0} ${radius * 2} ${radius * 2}`}
  bind:this={VIEWS.svg}
  style="--circumference: {strokeDashoffset}">
  <circle
    stroke="#ebebeb"
    stroke-dasharray={circumference + ' ' + circumference}
    stroke-width={stroke}
    fill="transparent"
    r={normalizedRadius}
    cx={radius}
    cy={radius} />
  {#if showRating}
    <circle
      class="progress-indicator"
      in:grow={{ duration: 1000 }}
      stroke={getColorForRating(progress)}
      stroke-dasharray={circumference + ' ' + circumference}
      stroke-width={stroke}
      fill="transparent"
      r={normalizedRadius}
      cx={radius}
      cy={radius} />
  {/if}
  <text
    x="50%"
    y="50%"
    font-size="32px"
    font-weight="600"
    text-anchor="middle"
    fill={getColorForRating(progress)}
    dy=".35em">
    {Math.round(overallDisplay*100/maxRating) + '%'}
  </text>
</svg>
